import {
  AfterContentInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  SimpleChanges,
  EventEmitter,
  Renderer2,
} from "@angular/core";

// import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
// import { AngularEditorConfig } from '@kolkov/angular-editor';

// import * as ZeebeBpmnModdle from "zeebe-bpmn-moddle/resources/zeebe.json";
// import {
//   BpmnPropertiesPanelModule,
//   BpmnPropertiesProviderModule,
//   ZeebePropertiesProviderModule,
// } from "bpmn-js-properties-panel";

// import serviceTaskProviderModule from "../../../../customElements/provider/serviceTask";
// import * as serviceTaskDescriptor from "../../../../customElements/descriptors/serviceTaskDescriptor.json";

// import { HttpClient } from "@angular/common/http";

// import type Canvas from "diagram-js/lib/core/Canvas";
// import type { ImportDoneEvent, ImportXMLResult } from "bpmn-js";

// import customTranslate from "../../../../customTranslate/customTranslate";

// import { CreateAppendAnythingModule } from "bpmn-js-create-append-anything";

// import { ZeebeVariableResolverModule } from "@bpmn-io/variable-resolver";

// import BpmnJS from "bpmn-js/lib/Modeler";
// import ZeebeBehaviorsModule from "camunda-bpmn-js-behaviors/lib/camunda-cloud";
// import gridModule from "diagram-js-grid";

// import {
//   getProcessVariables,
//   getVariablesForScope,
// } from "@bpmn-io/extract-process-variables";

// import { BaseServiceService } from "src/app/services/base-service.service";
// import { Observable, Subscription, lastValueFrom } from "rxjs";
// import { ModalNotifyTypes } from "../modal-notify/modal-notify.component";
// import { Router } from "@angular/router";
// import diagramXML from "../../../assets/newDiagram";

import { AppData } from "src/app/helpers/app-data";

/* import { from, Observable, Subscription } from 'rxjs';
 */
declare var fabric: any;

@Component({
  selector: "app-diagram",
  templateUrl: "./diagram.component.html",
  styles: [ ],
})
export class DiagramComponent
  implements AfterContentInit, OnChanges, OnDestroy, OnInit
{
  
  Data: any = AppData.DIAGRAM_URL;

  ngAfterContentInit(): void {

  }

  ngOnInit(): void {
    $('#IDiagramFrame').attr('src', AppData.DIAGRAM_URL); 
  }

  ngOnChanges(changes: SimpleChanges) {}

  ngOnDestroy(): void {
    
  }

  
}

export class Proceso {
  Nombre: string;
  Descripcion: string;
  Estado: number;
  Version: number;
  Configuracion: string;
  TodosUsuarios: boolean;
  Activo: boolean;

  constructor() {
    this.Nombre = "";
    this.Descripcion = "";
    this.Estado = null;
    this.Version = null;
    this.Configuracion = "";
    this.TodosUsuarios = false;
    this.Activo = false;
  }
}

export class TareaConfig {
  IdProceso: number;
  IdTarea: string;
  Configuracion: string;

  constructor() {
    this.IdProceso = null;
    this.IdTarea = null;
    this.Configuracion = "";
  }
}
